import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef, useContext } from "react";
import * as Styled from "./Card.styled";
import { CardContext } from "./CardGroup";
export const Card = forwardRef((props, ref) => {
    /* istanbul ignore next */
    const { children, hasBorder, hasHoverEffect, hasOverflow, shadowDepth, width, ...otherProps } = props;
    const cardGroupContext = useContext(CardContext);
    const border = Boolean(hasBorder === undefined
        ? cardGroupContext.cardProps !== undefined && cardGroupContext.cardProps.hasBorder !== undefined
            ? cardGroupContext.cardProps.hasBorder
            : false
        : hasBorder);
    const shadow = shadowDepth === undefined
        ? cardGroupContext.cardProps !== undefined && cardGroupContext.cardProps.shadowDepth !== undefined
            ? cardGroupContext.cardProps.shadowDepth
            : "card"
        : shadowDepth;
    const hover = Boolean(hasHoverEffect === undefined
        ? cardGroupContext.cardProps === undefined
            ? false
            : cardGroupContext.cardProps.hasHoverEffect
        : hasHoverEffect);
    return (_jsx(Styled.Card, { "data-testid": "Card", ref: ref, shadowDepth: shadow, hasBorder: border, hasHoverEffect: hover, hasOverflow: Boolean(hasOverflow), width: width, ...otherProps, children: children }));
});
Card.defaultProps = {
    width: "auto"
};
Card.displayName = "Card";
